import * as THREE from 'three';
import { PuzzleElement } from './PuzzleElement';

export class HiddenPlatform extends PuzzleElement {
  private isRevealed: boolean = false;
  private targetOpacity: number = 0;
  private currentOpacity: number = 0;
  private material: THREE.MeshStandardMaterial;
  
  constructor(position: THREE.Vector3, size: THREE.Vector3) {
    super(position);
    
    // Update mesh size
    (this.mesh as THREE.Mesh).geometry.dispose();
    (this.mesh as THREE.Mesh).geometry = new THREE.BoxGeometry(size.x, size.y, size.z);
    
    this.material = (this.mesh as THREE.Mesh).material as THREE.MeshStandardMaterial;
  }
  
  protected createMesh(): THREE.Mesh {
    const geometry = new THREE.BoxGeometry(3, 0.5, 3);
    const material = new THREE.MeshStandardMaterial({ 
      color: 0xffffcc,
      transparent: true,
      opacity: 0,
      roughness: 0.5,
      metalness: 0.3,
      emissive: 0xffffcc,
      emissiveIntensity: 0.2
    });
    
    const mesh = new THREE.Mesh(geometry, material);
    mesh.receiveShadow = true;
    mesh.castShadow = true;
    
    return mesh;
  }
  
  public update(deltaTime: number, _playerPosition: THREE.Vector3): void {
    // Smoothly transition opacity
    this.currentOpacity += (this.targetOpacity - this.currentOpacity) * deltaTime * 3;
    this.material.opacity = this.currentOpacity;
  }
  
  public reveal(hasLightAura: boolean): void {
    this.isRevealed = hasLightAura;
    this.targetOpacity = hasLightAura ? 0.9 : 0;
  }
  
  public isRevealedState(): boolean {
    return this.isRevealed && this.currentOpacity > 0.5;
  }
  
  public getCollisionBox(): THREE.Box3 | null {
    if (this.isRevealedState()) {
      return new THREE.Box3().setFromObject(this.mesh);
    }
    return null;
  }
}
